import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'egi-info',
  templateUrl: './egi-info.component.html',
  styleUrls: ['./egi-info.component.css'],
})
export class EgiInfoComponent implements OnInit {
  @Input() info;
  constructor() {}

  ngOnInit(): void {}
}
